// extracted by mini-css-extract-plugin
export var currencyInput = "_iz-1";
export var currencySymbol = "_iz-0";